/**
 * @file: FridgeOpen.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 留样冰箱开启记录管理
 */
import request from '@/utils/request'

/**
 * 新增留样冰箱开启记录
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function fridgeRecordAdd(data) {
  return request({
    type: 'device',
    url: 'fridge/record/add',
    method: 'post',
    data
  })
}

/**
 * 留样冰箱开启记录列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function fridgeRecordListGet(data) {
  return request({
    type: 'device',
    url: 'fridge/record/list/get',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/FridgeOpen.js